import React from 'react';
import Button from '../../components/Button/Button';

interface PartnerRequestFormProps {
    // AB#1453: 'signup' added to match the updated FormType.
    toggleForm: (form: 'login' | 'forgetPassword' | 'partner' | 'signup') => void;
}

const PartnerRequestForm: React.FC<PartnerRequestFormProps> = ({ toggleForm }) => (
    <div>
        <h2>Partner request</h2>
        <p>Partner request form will be wired in a later phase.</p>
        <Button label="Back to login" onClick={() => toggleForm('login')} />
    </div>
);

export default PartnerRequestForm;
